import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const FerryPictogram = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M5.68533 11.7333C6.4048 11.7429 7.09995 11.9947 7.65867 12.448L7.936 12.6933H7.98933L8.32 12.3947C9.36715 11.5291 10.8576 11.4511 11.9893 12.2027L14.4 7.46667L12.8 6.4V2.61333C12.7503 1.76 12.0545 1.08747 11.2 1.06667H10.6667C10.7033 0.514133 10.2849 0.0365869 9.73237 1.90509e-07C9.68832 -0.00287981 9.64405 -0.00287981 9.6 1.90509e-07H6.4C5.84747 -0.0365865 5.36992 0.38176 5.33333 0.934293C5.33045 0.978347 5.33045 1.02261 5.33333 1.06667H4.8C3.94549 1.08747 3.24971 1.76 3.2 2.61333V6.4L1.6 7.46667L4 12.2987C4.49525 11.951 5.08064 11.7547 5.68533 11.7333ZM4.26667 2.61333C4.27787 2.33664 4.51125 2.12149 4.78784 2.13269C4.79189 2.13291 4.79595 2.13312 4.8 2.13333H11.2C11.4763 2.11509 11.7151 2.32416 11.7333 2.60043C11.7348 2.62251 11.7348 2.64459 11.7333 2.66667V5.86667L8 3.73333L4.26667 5.81333V2.61333ZM14.9333 13.8667V14.9333C14.6532 14.954 14.3926 15.0844 14.208 15.296C13.9182 15.6035 13.549 15.825 13.1413 15.936C12.4857 16.1296 11.7765 15.9813 11.2533 15.5413L10.8373 15.168C10.5127 14.8452 9.98859 14.8452 9.664 15.168C9.51467 15.296 9.376 15.4347 9.216 15.5627C8.43435 16.1873 7.31584 16.1557 6.57067 15.488L6.15467 15.1147C5.84917 14.8478 5.39349 14.8478 5.088 15.1147C4.88533 15.2747 4.704 15.456 4.50133 15.616C3.75008 16.1723 2.71659 16.1459 1.99467 15.552L1.664 15.264C1.50965 15.0873 1.29835 14.9702 1.06667 14.9333V13.8667C1.3424 13.8325 1.62187 13.8847 1.86667 14.016C2.16341 14.1997 2.44523 14.4065 2.70933 14.6347C2.92811 14.8731 3.25835 14.9749 3.57333 14.9013C3.69333 14.8658 3.80555 14.8079 3.904 14.7307C4.07467 14.6027 4.21333 14.4533 4.384 14.3147C5.14197 13.6866 6.23936 13.6866 6.99733 14.3147C7.168 14.4533 7.328 14.6133 7.49867 14.752C7.80416 15.0189 8.25984 15.0189 8.56533 14.752C8.736 14.6133 8.896 14.4533 9.06667 14.3147C9.82645 13.6807 10.9309 13.6807 11.6907 14.3147C11.8507 14.4533 12 14.6027 12.16 14.7307C12.4655 14.9975 12.9212 14.9975 13.2267 14.7307L13.728 14.2933C14.0688 14.0169 14.4945 13.8661 14.9333 13.8667Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { FerryPictogram };